import FantasyLabsService from '../../services/fantasyLabsService';
import * as actionTypes from '../../constants/actionTypes';
import moment from 'moment-timezone';

export function setActiveSport(sportName) {
    return {
        type: actionTypes.PROPSRESULTS_ACTIVE_SPORT_CHANGED,
        activeSport: sportName
    };
}

export function getPropsResults(
    sessionId,
    sportId,
    sportName,
    startDate,
    endDate,
    teamId,
    oppTeamId,
    position,
    statId,
    sportsbook,
    playerName,
    side
) {
    return (dispatch, getState) => {
        dispatch(fetching(sportName));

        const timeFormat = 'YYYY-MM-DDTHH:mm';
        const start_date = moment(startDate)
            .utc()
            .format(timeFormat);

        const end_date = moment(endDate)
            .utc()
            .format(timeFormat);

        const service = new FantasyLabsService(dispatch, getState);
        return service.getPropsResults(
            sessionId,
            sportId,
            start_date,
            end_date,
            teamId,
            oppTeamId,
            position,
            statId,
            sportsbook,
            playerName,
            side,
            err => dispatch(failed(sportName, err)),
            json => dispatch(success(sportName, json))
        );
    };
}

function fetching(sportName) {
    return {
        type: actionTypes.PROPSRESULTS_FETCHING,
        sportName: sportName
    };
}

function success(sportName, json) {
    let results = [];
    if (json && json.Results) {
        results = [...json.Results];
    }

    return {
        type: actionTypes.PROPSRESULTS_SUCCESS,
        sportName: sportName,
        propsResults: results
    };
}

function failed(sportName, err) {
    return {
        type: actionTypes.PROPSRESULTS_FAILED,
        sportName: sportName,
        errorMessage: err
    };
}



// WEBPACK FOOTER //
// ./src/redux/actions/propsResults.js